import {decorate, observable, action} from 'mobx';

class TooltipStore {
    currentText = ''
    currentStyle = ''
    isVisible = false

    setText(text) {
        this.currentText = text
    }

    setStyle(style) {
        this.currentStyle = style
    }

    setVisibility(visible) {
        if (visible) {
            this.show()
        } else {
            this.hide()
        }
    }

    show() {
        this.isVisible = true
    }

    hide() {
        this.isVisible = false
    }
}

decorate(TooltipStore, {
    currentText: observable,
    currentStyle: observable,
    isVisible: observable,

    setText: action,
    setStyle: action,
    setVisibility: action,
    show: action,
    hide: action
})

const store = new TooltipStore();
export default store;